const { size } = require('lodash');
const { default: Ajv } = require('ajv');
const { ValidationError } = require('./validation-error');

const ajv = new Ajv({
    allErrors: true,
    strictTuples: false
});

function validateSchema(schema, request) {

    const errors = getValidationErrors(schema, request);

    if (size(errors) > 0) {

        throw new ValidationError(errors);
    }
}

function getValidationErrors(schema, request) {

    const validate = ajv.compile(schema);

    const valid = validate(request);

    return valid ? [] : validate.errors;
}

module.exports = {
    validateSchema,
    getValidationErrors
};
